import styled from 'styled-components';
import { Box, Paper } from '@mui/material';

export const ForgotPasswordContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
`;

export const StyledForgotPaper = styled(Paper)`
  padding: 48px;
  width: 100%;
  max-width: 500px;
  border-radius: 24px !important; // Bordes redondeados profesionales
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04) !important; // Sombra minimalista
  text-align: left;
`;

export const FormWrapper = styled.div`
  margin-top: 32px;
`;
